import type { MisconceptionDefinition } from './types'

/** SPR — Spelling regels misconcepties. */
export const SPR_MISCONCEPTIONS: MisconceptionDefinition[] = [
  {
    id: 'spr.dt-confusion',
    label: 'D/T-fout',
    module: 'SpellingRegel',
    description:
      'Leerling past de d/t-regel verkeerd toe bij werkwoordsvormen.',
    typicalFamilies: ['SPR-WEET-D-T', 'SPR-WEET-DT'],
  },
  {
    id: 'spr.double-consonant',
    label: 'Verdubbeling vergeten',
    module: 'SpellingRegel',
    description:
      'Leerling vergeet de medeklinkerverdubbeling (bijv. "baken" i.p.v. "bakken").',
    typicalFamilies: ['SPR-KLANK-BAKKER', 'SPR-KLANK-VERDUBBEL'],
  },
  {
    id: 'spr.ei-ij-confusion',
    label: 'Ei/ij verwisseld',
    module: 'SpellingRegel',
    description: 'Leerling verwisselt ei en ij in woorden.',
    typicalFamilies: ['SPR-WEET-EI-IJ'],
  },
  {
    id: 'spr.open-closed-syllable',
    label: 'Open/gesloten lettergreep',
    module: 'SpellingRegel',
    description:
      'Leerling herkent het verschil niet tussen open en gesloten lettergrepen.',
    typicalFamilies: ['SPR-KLANK-JAGER', 'SPR-KLANK-VERKORTEN'],
  },
  {
    id: 'spr.au-ou-confusion',
    label: 'Au/ou verwisseld',
    module: 'SpellingRegel',
    description: 'Leerling verwisselt au en ou in woorden.',
    typicalFamilies: ['SPR-KLANK-AU-OU'],
  },
  {
    id: 'spr.loanword-phonetic-dutch',
    label: 'Leenwoord fonetisch vernederlandst',
    module: 'SpellingRegel',
    description:
      'Leerling schrijft een leenwoord fonetisch zoals het in het Nederlands klinkt, in plaats van de oorspronkelijke spelling te behouden (bijv. "djiens" i.p.v. "jeans").',
    typicalFamilies: ['SPR-LEEN-ENGELS', 'SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.loanword-partial-phonetic',
    label: 'Leenwoord deels fonetisch',
    module: 'SpellingRegel',
    description:
      'Leerling past een deel van het leenwoord fonetisch aan maar behoudt een ander deel (bijv. "highlite" i.p.v. "highlight").',
    typicalFamilies: ['SPR-LEEN-ENGELS'],
  },
  {
    id: 'spr.linking-n-forgotten',
    label: 'Tussen-n vergeten',
    module: 'SpellingRegel',
    description:
      'Leerling vergeet de tussen-n (meervouds-en) in een samenstelling (bijv. "pannekoek" i.p.v. "pannenkoek").',
    typicalFamilies: ['SPR-SAM-TUSSEN-N'],
  },
  {
    id: 'spr.linking-n-singular',
    label: 'Enkelvoud i.p.v. meervoud in samenstelling',
    module: 'SpellingRegel',
    description:
      'Leerling gebruikt het enkelvoud in plaats van het meervoud als eerste deel van de samenstelling (bijv. "pankoek" i.p.v. "pannenkoek").',
    typicalFamilies: ['SPR-SAM-TUSSEN-N'],
  },
  {
    id: 'spr.compound-split',
    label: 'Samenstelling los geschreven',
    module: 'SpellingRegel',
    description:
      'Leerling schrijft een samenstelling als twee losse woorden (bijv. "pannen koek" i.p.v. "pannenkoek").',
    typicalFamilies: ['SPR-SAM-TUSSEN-N', 'SPR-SAM-TUSSEN-S'],
  },
  {
    id: 'spr.linking-s-forgotten',
    label: 'Tussen-s vergeten',
    module: 'SpellingRegel',
    description:
      'Leerling vergeet de tussen-s in een samenstelling (bijv. "dorpplein" i.p.v. "dorpsplein").',
    typicalFamilies: ['SPR-SAM-TUSSEN-S'],
  },
  {
    id: 'spr.linking-s-confused-en',
    label: 'Tussen-s verward met tussen-en',
    module: 'SpellingRegel',
    description:
      'Leerling verwart een samenstelling met tussen-s met een samenstelling met tussen-en, of omgekeerd.',
    typicalFamilies: ['SPR-SAM-TUSSEN-S', 'SPR-SAM-TUSSEN-N'],
  },
  {
    id: 'spr.trema-forgotten',
    label: 'Trema vergeten',
    module: 'SpellingRegel',
    description:
      'Leerling vergeet de trema bij klinkerbotsing in het meervoud (bijv. "bacterien" i.p.v. "bacteriën").',
    typicalFamilies: ['SPR-TREMA-MV'],
  },
  {
    id: 'spr.trema-apostrophe',
    label: 'Apostrof i.p.v. trema',
    module: 'SpellingRegel',
    description:
      'Leerling gebruikt een apostrof in plaats van een trema bij het meervoud (bijv. "bacterie\'s" i.p.v. "bacteriën").',
    typicalFamilies: ['SPR-TREMA-MV'],
  },
  {
    id: 'spr.trema-extra-vowel',
    label: 'Extra klinker bij trema',
    module: 'SpellingRegel',
    description:
      'Leerling voegt een extra klinker toe bij het meervoud met trema (bijv. "bacterieën" i.p.v. "bacteriën").',
    typicalFamilies: ['SPR-TREMA-MV'],
  },
  {
    id: 'spr.accent-forgotten',
    label: 'Accent vergeten',
    module: 'SpellingRegel',
    description:
      'Leerling vergeet het accent op een Frans leenwoord of klemtoonwoord (bijv. "resume" i.p.v. "résumé").',
    typicalFamilies: ['SPR-ACCENT'],
  },
  {
    id: 'spr.accent-partial',
    label: 'Accent maar op één positie',
    module: 'SpellingRegel',
    description:
      'Leerling plaatst het accent op slechts één van meerdere vereiste posities (bijv. "résume" of "resumé" i.p.v. "résumé").',
    typicalFamilies: ['SPR-ACCENT'],
  },
  {
    id: 'spr.accent-type-confused',
    label: 'Accenttype verward',
    module: 'SpellingRegel',
    description:
      'Leerling verwart accent aigu (é), accent grave (è), accent circumflex (ê) en trema (ë) met elkaar.',
    typicalFamilies: ['SPR-ACCENT'],
  },
  {
    id: 'spr.latin-plural-english-s',
    label: 'Engels meervoud i.p.v. Latijns',
    module: 'SpellingRegel',
    description:
      'Leerling gebruikt het Engelse meervoud met -s in plaats van het Latijnse meervoud (bijv. "museums" i.p.v. "musea").',
    typicalFamilies: ['SPR-LEEN-LATIJN'],
  },
  {
    id: 'spr.latin-plural-dutch-en',
    label: 'Nederlands meervoud i.p.v. Latijns',
    module: 'SpellingRegel',
    description:
      'Leerling gebruikt het Nederlandse meervoud met -en in plaats van het Latijnse meervoud (bijv. "museumen" i.p.v. "musea").',
    typicalFamilies: ['SPR-LEEN-LATIJN'],
  },
  {
    id: 'spr.latin-plural-apostrophe',
    label: 'Apostrof-meervoud bij Latijns woord',
    module: 'SpellingRegel',
    description:
      'Leerling gebruikt een apostrof voor het meervoud van een Latijns woord (bijv. "museum\'s" i.p.v. "musea").',
    typicalFamilies: ['SPR-LEEN-LATIJN'],
  },
  {
    id: 'spr.greek-origin-confused',
    label: 'Griekse herkomst verward',
    module: 'SpellingRegel',
    description:
      'Leerling verwart Griekse leenwoorden met Franse of Engelse leenwoorden, of herkent Griekse woorddelen niet.',
    typicalFamilies: ['SPR-LEEN-GRIEKS'],
  },
  {
    id: 'spr.greek-spelling-english',
    label: 'Engelse spelling bij Grieks woord',
    module: 'SpellingRegel',
    description:
      'Leerling gebruikt de Engelse spellingvariant van een Grieks woord in het Nederlands (bijv. "filosofy" i.p.v. "filosofie", of behoudt "ph" i.p.v. "f").',
    typicalFamilies: ['SPR-LEEN-GRIEKS'],
  },
  {
    id: 'spr.c-klank-k-als-s',
    label: 'K-klank als S-klank gezien',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat C vóór a, o of u als S klinkt (terwijl het K is).',
    typicalFamilies: ['SPR-LEEN-C-S-K'],
  },
  {
    id: 'spr.c-klank-s-als-k',
    label: 'S-klank als K-klank gezien',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat C vóór e of i als K klinkt (terwijl het S is).',
    typicalFamilies: ['SPR-LEEN-C-S-K'],
  },
  {
    id: 'spr.c-altijd-k',
    label: 'Denkt C altijd K',
    module: 'SpellingRegel',
    description: 'Leerling denkt dat de letter C altijd als K klinkt.',
    typicalFamilies: ['SPR-LEEN-C-S-K'],
  },
  {
    id: 'spr.c-altijd-s',
    label: 'Denkt C altijd S',
    module: 'SpellingRegel',
    description: 'Leerling denkt dat de letter C altijd als S klinkt.',
    typicalFamilies: ['SPR-LEEN-C-S-K'],
  },
  {
    id: 'spr.c-niet-leenwoord',
    label: 'C-woord niet als leenwoord herkend',
    module: 'SpellingRegel',
    description:
      'Leerling herkent niet dat woorden met C leenwoorden zijn die hun originele spelling behouden.',
    typicalFamilies: ['SPR-LEEN-C-S-K'],
  },
  {
    id: 'spr.c-klank-onhoorbaar',
    label: 'Denkt C onhoorbaar',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat de C in bepaalde woorden niet hoorbaar is.',
    typicalFamilies: ['SPR-LEEN-C-S-K'],
  },
  {
    id: 'spr.au-ou-verward',
    label: 'Au en ou verward',
    module: 'SpellingRegel',
    description:
      'Leerling verwart au-woorden met ou-woorden of omgekeerd (weetwoorden).',
    typicalFamilies: ['SPR-KLANK-AU-OU'],
  },
  {
    id: 'spr.dubbel-klinker-open',
    label: 'Dubbele klinker in open lettergreep',
    module: 'SpellingRegel',
    description:
      'Leerling schrijft een dubbele klinker (aa, ee, oo) in een open lettergreep waar één klinker volstaat.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.dubbel-klinker-en-medeklinker',
    label: 'Dubbele klinker én medeklinker',
    module: 'SpellingRegel',
    description:
      'Leerling verdubbelt zowel de klinker als de medeklinker (bijv. "maannen" i.p.v. "manen").',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.maan-man-verward',
    label: 'Maan/man meervoud verward',
    module: 'SpellingRegel',
    description:
      'Leerling verwart het meervoud van îén (manen) met het meervoud van één (mannen).',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.hoofdletter-dag',
    label: 'Hoofdletter bij dag',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat dagen van de week een hoofdletter krijgen (Engels-invloed).',
    typicalFamilies: ['SPR-HOOFDLETTER'],
  },
  {
    id: 'spr.hoofdletter-znw',
    label: 'Hoofdletter bij gewoon znw',
    module: 'SpellingRegel',
    description:
      'Leerling geeft gewone zelfstandige naamwoorden een hoofdletter (Duits-invloed).',
    typicalFamilies: ['SPR-HOOFDLETTER'],
  },
  {
    id: 'spr.hoofdletter-ww',
    label: 'Hoofdletter bij werkwoord',
    module: 'SpellingRegel',
    description: 'Leerling geeft werkwoorden onterecht een hoofdletter.',
    typicalFamilies: ['SPR-HOOFDLETTER'],
  },
  {
    id: 'spr.hoofdletter-zinsbegin-vergeten',
    label: 'Hoofdletter zinsbegin vergeten',
    module: 'SpellingRegel',
    description: 'Leerling vergeet de hoofdletter aan het begin van een zin.',
    typicalFamilies: ['SPR-HOOFDLETTER'],
  },
  {
    id: 'spr.hoofdletter-familienaam',
    label: 'Hoofdletter bij familieaanduiding',
    module: 'SpellingRegel',
    description:
      'Leerling geeft familieaanduidingen (oma, opa) onterecht een hoofdletter.',
    typicalFamilies: ['SPR-HOOFDLETTER'],
  },
  {
    id: 'spr.hoofdletter-geen-nodig',
    label: 'Denkt geen hoofdletters nodig',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat er geen hoofdletters nodig zijn in een zin.',
    typicalFamilies: ['SPR-HOOFDLETTER'],
  },
  {
    id: 'spr.hoofdletter-zinsbegin-onterecht',
    label: 'Zinsbegin-hoofdletter als fout gezien',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat de hoofdletter aan het zinsbegin onterecht is.',
    typicalFamilies: ['SPR-HOOFDLETTER'],
  },
  {
    id: 'spr.hoofdletter-naam-onterecht',
    label: 'Naam-hoofdletter als fout gezien',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat de hoofdletter bij een persoonsnaam onterecht is.',
    typicalFamilies: ['SPR-HOOFDLETTER'],
  },
  {
    id: 'spr.hoofdletter-plaats-onterecht',
    label: 'Plaats-hoofdletter als fout gezien',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat de hoofdletter bij een plaatsnaam onterecht is.',
    typicalFamilies: ['SPR-HOOFDLETTER'],
  },
  {
    id: 'spr.leesteken-punt-ipv-komma',
    label: 'Punt i.p.v. komma',
    module: 'SpellingRegel',
    description:
      'Leerling kiest een punt waar een komma past (bij verbonden zinsdelen).',
    typicalFamilies: ['SPR-LEESTEKEN-PUNT-KOMMA'],
  },
  {
    id: 'spr.leesteken-uitroep-verkeerd',
    label: 'Uitroepteken bij mededeling',
    module: 'SpellingRegel',
    description: 'Leerling kiest een uitroepteken bij een gewone mededeling.',
    typicalFamilies: ['SPR-LEESTEKEN-PUNT-KOMMA'],
  },
  {
    id: 'spr.leesteken-dubbele-punt-verkeerd',
    label: 'Dubbele punt verkeerd gebruikt',
    module: 'SpellingRegel',
    description: 'Leerling kiest een dubbele punt waar een komma of punt past.',
    typicalFamilies: ['SPR-LEESTEKEN-PUNT-KOMMA'],
  },
  {
    id: 'spr.leen-fonetisch-schrijven',
    label: 'Leenwoord fonetisch geschreven',
    module: 'SpellingRegel',
    description:
      'Leerling schrijft een Frans leenwoord fonetisch (bijv. "kado" i.p.v. "cadeau").',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-dubbele-klinker',
    label: 'Dubbele klinker bij leenwoord',
    module: 'SpellingRegel',
    description:
      'Leerling verdubbelt een klinker voor de lange klank bij een leenwoord (bijv. "kadoo").',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-half-frans',
    label: 'Half-Franse spelling',
    module: 'SpellingRegel',
    description:
      'Leerling herkent het begin van een Frans woord maar niet de uitgang (bijv. "cadoo").',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-oir-als-oar',
    label: 'Schrijft -oir als -oar',
    module: 'SpellingRegel',
    description: 'Leerling schrijft de Franse uitgang -oir als -oar.',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-fonetisch-trotwar',
    label: 'Trottoir fonetisch geschreven',
    module: 'SpellingRegel',
    description: 'Leerling schrijft trottoir fonetisch als "trotwar".',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-verkeerde-uitgang-uar',
    label: 'Verzint uitgang -uar',
    module: 'SpellingRegel',
    description:
      'Leerling verzint een niet-bestaande uitgang -uar bij een Frans leenwoord.',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-au-als-ou',
    label: 'Schrijft -au- als -ou-',
    module: 'SpellingRegel',
    description:
      'Leerling schrijft de Franse -au- als -ou- (bijv. "restourant").',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-ant-als-and',
    label: 'Schrijft -ant als -and',
    module: 'SpellingRegel',
    description: 'Leerling schrijft de Franse uitgang -ant als -and.',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-au-weggelaten',
    label: 'Laat -au- weg',
    module: 'SpellingRegel',
    description:
      'Leerling laat de -au- lettercombinatie weg in een Frans leenwoord.',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-age-als-asje',
    label: 'Schrijft -age als -asje',
    module: 'SpellingRegel',
    description:
      'Leerling schrijft de Franse uitgang -age fonetisch als -asje.',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-age-als-aazje',
    label: 'Schrijft -age als -aazje',
    module: 'SpellingRegel',
    description: 'Leerling schrijft de Franse uitgang -age als -aazje.',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-dubbele-r',
    label: 'Verdubbelt r bij leenwoord',
    module: 'SpellingRegel',
    description:
      'Leerling verdubbelt de r in een Frans leenwoord (bijv. "garrage").',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-balkon-als-frans',
    label: 'Balkon als Frans gezien',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat "balkon" een Frans leenwoord is (is Italiaans).',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-hotel-als-frans',
    label: 'Hotel als Frans gezien',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat "hotel" een Frans leenwoord is (is Latijn).',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-uitzicht-als-leen',
    label: 'Uitzicht als leenwoord gezien',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat "uitzicht" een leenwoord is (is Nederlands).',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-parasol-als-nl',
    label: 'Parasol als Nederlands gezien',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat "parasol" een Nederlands woord is (is Frans).',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-terras-als-nl',
    label: 'Terras als Nederlands gezien',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat "terras" een Nederlands woord is (is Frans).',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.leen-brochure-als-nl',
    label: 'Brochure als Nederlands gezien',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat "brochure" een Nederlands woord is (is Frans).',
    typicalFamilies: ['SPR-LEEN-FRANS'],
  },
  {
    id: 'spr.single-consonant-long-vowel',
    label: 'Enkele medeklinker geeft lange klank',
    module: 'SpellingRegel',
    description:
      'Leerling vergeet de medeklinker te verdubbelen, waardoor de klank lang wordt (bijv. "katen" i.p.v. "katten").',
    typicalFamilies: ['SPR-KLANK-BAKKER', 'SPR-KLANK-VERDUBBEL'],
  },
  {
    id: 'spr.wrong-syllable-split',
    label: 'Verkeerde lettergreepverdeling',
    module: 'SpellingRegel',
    description:
      'Leerling verdeelt het woord verkeerd in lettergrepen (bijv. "ka-tten" i.p.v. "kat-ten").',
    typicalFamilies: ['SPR-KLANK-VERDUBBEL'],
  },
  {
    id: 'spr.double-consonant-correct',
    label: 'Correct verdubbeld woord als fout gezien',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat een correct verdubbeld woord (bommen, netten) fout is.',
    typicalFamilies: ['SPR-KLANK-VERDUBBEL'],
  },
  {
    id: 'spr.vowel-doubled-instead',
    label: 'Klinker verdubbeld i.p.v. medeklinker',
    module: 'SpellingRegel',
    description:
      'Leerling verdubbelt de klinker in plaats van de medeklinker (bijv. "baakken" i.p.v. "bakken").',
    typicalFamilies: ['SPR-KLANK-BAKKER', 'SPR-KLANK-VERDUBBEL'],
  },
  {
    id: 'spr.triple-consonant',
    label: 'Drie medeklinkers i.p.v. twee',
    module: 'SpellingRegel',
    description:
      'Leerling schrijft drie medeklinkers in plaats van twee (bijv. "kopppen" i.p.v. "koppen").',
    typicalFamilies: ['SPR-KLANK-VERDUBBEL'],
  },
  {
    id: 'spr.double-consonant-for-long-vowel',
    label: 'Verdubbeling bij lange klank (niet nodig)',
    module: 'SpellingRegel',
    description:
      'Leerling verdubbelt de medeklinker ook bij woorden met een lange klank (bijv. denkt dat "boom → boommen").',
    typicalFamilies: ['SPR-KLANK-VERDUBBEL'],
  },
  {
    id: 'spr.english-ck-spelling',
    label: 'Engelse ck-spelling toegepast',
    module: 'SpellingRegel',
    description:
      'Leerling past de Engelse ck-spelling toe in het Nederlands (bijv. "bakcker" i.p.v. "bakker").',
    typicalFamilies: ['SPR-KLANK-BAKKER'],
  },
  {
    id: 'spr.wrong-vowel-stem',
    label: 'Verkeerde klinker uit stam',
    module: 'SpellingRegel',
    description:
      'Leerling gebruikt de verkeerde klinker uit de stam bij verbuiging.',
    typicalFamilies: ['SPR-KLANK-BAKKER'],
  },
  {
    id: 'spr.vowel-doubled-in-open-syllable',
    label: 'Dubbele klinker behouden in open lettergreep',
    module: 'SpellingRegel',
    description:
      'Leerling behoudt de dubbele klinker in een open lettergreep (bijv. "boomen" i.p.v. "bomen").',
    typicalFamilies: ['SPR-KLANK-VERKORTEN', 'SPR-KLANK-JAGER'],
  },
  {
    id: 'spr.short-vowel-doubling-confused',
    label: 'Korte klank verward met lange klank',
    module: 'SpellingRegel',
    description:
      'Leerling verwart het meervoud van woorden met korte en lange klanken (bijv. "mannen" vs "manen").',
    typicalFamilies: ['SPR-KLANK-VERKORTEN'],
  },
  {
    id: 'spr.no-plural-suffix',
    label: 'Meervoudsuitgang vergeten',
    module: 'SpellingRegel',
    description: 'Leerling vergeet de meervoudsuitgang -en toe te voegen.',
    typicalFamilies: ['SPR-KLANK-VERKORTEN'],
  },
  {
    id: 'spr.short-vowel-confused',
    label: 'Denkt dat de klinker kort is',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat een lange klinker in een open lettergreep kort is.',
    typicalFamilies: ['SPR-KLANK-VERKORTEN'],
  },
  {
    id: 'spr.consonant-causes-long-vowel',
    label: 'Denkt dat medeklinker de lange klank veroorzaakt',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat de medeklinker achter de klinker de lange klank veroorzaakt, i.p.v. de open lettergreep.',
    typicalFamilies: ['SPR-KLANK-VERKORTEN'],
  },
  {
    id: 'spr.word-class-determines-rule',
    label: 'Denkt dat woordsoort de regel bepaalt',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat de spellingregel afhangt van de woordsoort (werkwoord, zelfstandig naamwoord) i.p.v. het type lettergreep.',
    typicalFamilies: ['SPR-KLANK-VERKORTEN'],
  },
  {
    id: 'spr.bomen-fout-gedacht',
    label: 'Correct gespeld woord als fout gezien',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat correct gespeld "bomen" fout is en "boomen" moet zijn.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.tweeklank-verward',
    label: 'Tweeklank verward met lange klinker',
    module: 'SpellingRegel',
    description:
      'Leerling verwart een tweeklank (oe, eu, ui) met een lange klinker (oo, ee, aa).',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.ramen-dubbel',
    label: 'Denkt dat ramen dubbele aa nodig heeft',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat "ramen" als "raamen" geschreven moet worden.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.dubbel-ee-open',
    label: 'Dubbele ee in open lettergreep',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat de dubbele "ee" nodig is in een open lettergreep (bijv. "beenen" i.p.v. "benen").',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.dubbel-klinker-en-medeklinker-ee',
    label: 'Verdubbelt zowel ee als medeklinker',
    module: 'SpellingRegel',
    description:
      'Leerling verdubbelt zowel de klinker als de medeklinker (bijv. "beennen").',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.bakker-jager-verward',
    label: 'Bakker-regel en jager-regel verward',
    module: 'SpellingRegel',
    description:
      'Leerling verwart de bakker-regel (korte klank, dubbele medeklinker) met de jager-regel (lange klank, enkele medeklinker).',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.correct-als-fout',
    label: 'Correct woord als fout gezien',
    module: 'SpellingRegel',
    description: 'Leerling denkt dat een correct gespeld woord fout is.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.betekenis-vs-spelling',
    label: 'Betekenisfout verward met spellingfout',
    module: 'SpellingRegel',
    description: 'Leerling verwart een betekenisfout met een spellingfout.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.medeklinker-focus',
    label: 'Focust op medeklinkers i.p.v. klinkers',
    module: 'SpellingRegel',
    description:
      'Leerling focust op medeklinkerfouten terwijl de klinkerregel het probleem is.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.open-dubbel-verward',
    label: 'Open lettergreep vereist twee klinkers',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat je in een open lettergreep twee klinkers naast elkaar schrijft.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.altijd-dubbel',
    label: 'Lange klinkers altijd dubbel',
    module: 'SpellingRegel',
    description:
      'Leerling denkt dat lange klinkers altijd dubbel geschreven worden, ongeacht het type lettergreep.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
  {
    id: 'spr.open-gesloten-omgedraaid',
    label: 'Open en gesloten lettergreep omgedraaid',
    module: 'SpellingRegel',
    description:
      'Leerling verwisselt de regels voor open en gesloten lettergrepen.',
    typicalFamilies: ['SPR-KLANK-AA-EE-OO'],
  },
]
